<template>
  <div class="extension_time__form">
    <h1>ยื่นขอขยายเวลา</h1>

    <v-layout class="d-flex align-center mt-6">
      <v-flex shrink mr-3>
        <v-img
          :src="
            require('../../../../assets/images/extension-time/calendar-add.png')
          "
          width="20"
          height="20"
        ></v-img>
      </v-flex>
      <v-flex shrink>
        <div class="font-20 font-w-600">รายละเอียดการขอขยายเวลา</div>
      </v-flex>
    </v-layout>

    <div class="custom_card mt-4">
      <v-layout wrap>
        <v-flex lg2 md3 class="font-14 font-w-600 mb-2">แผนงาน</v-flex>
        <v-flex lg10 md9>
          <div class="font-14 mb-2">
            {{ form.plan_name ? form.plan_name : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
        <v-flex lg2 md3 class="font-14 font-w-600">ชื่อโครงการ(ไทย)</v-flex>
        <v-flex lg10 md9>
          <div class="font-14">
            {{ form.project_name ? form.project_name : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
      </v-layout>
    </div>

    <div class="custom_card mt-4">
      <div class="font-20 font-w-700">แผนการดำเนินงานวิจัย</div>

      <v-layout class="mt-5">
        <v-flex xs2>
          <div class="font-14 font-w-600 mb-2">
            ครั้งที่ <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          {{ form.round ? form.round : "- ไม่มีข้อมูล -" }}
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs2>
          <div class="font-14 font-w-600 mb-3">
            ระยะเวลาที่ขยายเวลา (เดือน) <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          {{ form.duration ? form.duration : "- ไม่มีข้อมูล -" }}
          เดือน
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex xs2>
          <div class="font-14 font-w-600 mb-3">
            ขยายเวลาถึงวันที่ <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          {{ form.end_date ? toDateFormat(form.end_date) : "- ไม่มีข้อมูล -" }}
        </v-flex>
      </v-layout>

      <v-layout class="mb-3">
        <v-flex xs2>
          <div class="font-14 font-w-600">
            เหตุผล <span style="color: #f15a29">*</span>
          </div>
        </v-flex>
        <v-flex xs10>
          <div class="font-14">
            {{ form.reason ? form.reason : "- ไม่มีข้อมูล -" }}
          </div>
        </v-flex>
      </v-layout>

      <div class="font-14 font-w-700 mb-2">เอกสารเเนบ</div>

      <v-layout
        align-center
        class="mt-3"
        v-for="(file, f) in form.files"
        :key="f"
      >
        <v-flex shrink>
          <v-btn
            depressed
            dark
            rounded
            width="100"
            color="#F15A29"
            @click="downloadFile(file)"
          >
            <Iconify
              style="color: #fff"
              icon="system-uicons:download"
            ></Iconify>
            <span class="font-12 font-w-700">ดาวน์โหลด</span>
          </v-btn>
        </v-flex>
        <v-flex shrink ml-3>
          {{ file.file_name }}
        </v-flex>
      </v-layout>
    </div>

    <v-btn
      class="mt-6"
      rounded
      depressed
      color="#D9D9D9"
      @click="$router.push('/usp/extend-time')"
    >
      <span style="color: #464647">ย้อนกลับ</span>
    </v-btn>

    <!-- <pre>
      {{ form }}
    </pre> -->
  </div>
</template>

<script>
import DatePicker from "../../../../components/input/DatePicker.vue";
import SERVICES from "../../../../services";

import {
  toDateFormat,
  toDateTimeFormat,
  formatNumber,
} from "@/plugins/global-funcs";
export default {
  components: { DatePicker },
  data() {
    return {
      toDateFormat,
      form: {
        plan_name: "",
        project_name: "",
        //
        round: "",
        duration: "",
        start_date: "",
        end_date: "",
        reason: "",
        status: "",
        files: [],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        // const res = await SERVICES.USPExtend.show(this.$route.params.id);
        const data = await this.$apiFire(
          "USPExtend/show",
          this.$route.params.id
        );
        this.form = data;
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(file) {
      window.open(file.url, "_blank");
    },
  },
};
</script>

<style lang="scss">
.extension_time__form {
  .custom_card {
    background: #ffffff;
    box-shadow: 1px 1px 30px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 15px 25px;
  }
}
</style>
